/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_settings_debug_paymentredirecterror2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 페이지 이동 오류`)
};

const en_settings_debug_paymentredirecterror2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment page redirect error`)
};

const ja_settings_debug_paymentredirecterror2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`決済ページリダイレクトエラー`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const settings_debug_paymentredirecterror2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_debug_paymentredirecterror2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_debug_paymentredirecterror2", locale)
	if (locale === "ko") return ko_settings_debug_paymentredirecterror2(inputs)
	if (locale === "en") return en_settings_debug_paymentredirecterror2(inputs)
	return ja_settings_debug_paymentredirecterror2(inputs)
};
export { settings_debug_paymentredirecterror2 as "settings_debug_paymentRedirectError" }